import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=c4ca985c&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=c4ca985c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ca985c",
  null
  
)

export default component.exports